import type { ISelectConfig } from '../../forms/select/create';
import * as exSelect from '../../forms/select';

import type { IManagerConfig, IManagerApi } from './types';
import { mount } from './mount';

// ----------------------------------------------------------------------------

type TypeCreateConfig = ISelectConfig & {
    manager?: IManagerConfig;
};

// ----------------------------------------------------------------------------

function create(config: TypeCreateConfig): IManagerApi | undefined {
    if (!config.container?.parent) {
        throw new Error('Missing "container.parent", is required!');
    }

    const { manager, ...selectConfig } = config;

    const select = exSelect.create(selectConfig);

    return mount(select.element, manager);
}

function createMany(configs: TypeCreateConfig[] = []): IManagerApi[] {
    const managers: IManagerApi[] = [];

    for (const config of configs) {
        const manager = create(config);

        if (manager) {
            managers.push(manager);
        }
    }

    return managers;
}

// ----------------------------------------------------------------------------

export { create, createMany };
